// removed by extract-text-webpack-plugin
module.exports = {"noEditBanner":"NoPermissionsBanner-noEditBanner"};